<template>
  <v-row class="fill-height" align-content="center" justify="center" v-if="!isLogged">
    <v-col xs="12" sm="8" md="6" lg="6">
      <LoginForm
        :headerText="$t('ADMIN_PANEL')"
        @submit="handleLogin"
        :isError="lastLoginError"
        :submitting="submitting"
      />
    </v-col>
  </v-row>
</template>

<script>
  import { mapActions, mapState } from 'vuex';

  import { redirectToProperRoute } from '@/router/router';
  import LoginForm from '@/components/Login/LoginForm';
  import { AuthService } from '../utils/services/auth-service';

  export default {
    name: 'Login',
    components: { LoginForm },
    data() {
      return {
        lastLoginError: false,
        submitting: false,
      };
    },
    computed: {
      ...mapState('auth', ['userRoles', 'isLogged']),
    },
    created() {
      if (this.isLogged) {
        redirectToProperRoute(this.userRoles);
      }
    },
    methods: {
      ...mapActions('auth', ['refreshSession']),

      handleLogin({ username, password, cadence }) {
        this.submitting = true;
        AuthService.login(username, password, cadence)
          .then(res => {
            this.submitting = false;
            this.refreshSession({ token: res.data.token });
            redirectToProperRoute(this.userRoles);
          })
          .catch(() => {
            this.submitting = false;
            this.lastLoginError = true;
          });
      },
    },
  };
</script>
